import { baseApi } from "./baseApi";
import { buildPaginationQueryString } from "./queryHelpers";
import {
  PaginateQuery,
  CreateGradeRequest,
  UpdateGradeRequest,
} from "../../interfaces";

export const gradeApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getGrades: builder.query<any, PaginateQuery>({
      query: (data) => ({
        url: buildPaginationQueryString(data, "/api/grade"),
      }),
      providesTags: ["Grades"],
    }),
    getGrade: builder.query<any, string>({
      query: (id) => ({
        url: `/api/grade/${id}`,
      }),
      providesTags: ["Grade"],
    }),
    getGradeSelectListByCourse: builder.query<any, string>({
      query: (courseId) => ({
        url: `/api/grade/${courseId}/course`,
      }),
      providesTags: ["Grades-Select-List-By-Course"],
    }),
    addGrade: builder.mutation<any, CreateGradeRequest>({
      query: (data) => ({
        url: "/api/grade",
        method: "POST",
        body: data,
      }),
      invalidatesTags: [
        "Grades",
        "Grade",
        "Grades-Select-List-By-Course",
      ],
    }),
    updateGrade: builder.mutation<
      any,
      { id: string; data: UpdateGradeRequest }
    >({
      query: ({ id, data }) => ({
        url: `/api/grade/${id}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: [
        "Grades",
        "Grade",
        "Grades-Select-List-By-Course",
      ],
    }),
    deleteGrade: builder.mutation<any, string>({
      query: (id) => ({
        url: `/api/grade/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: [
        "Grades",
        "Grades-Select-List-By-Course",
      ],
    }),
  }),
});

export const {
  useGetGradesQuery,
  useGetGradeQuery,
  useGetGradeSelectListByCourseQuery,
  useLazyGetGradeSelectListByCourseQuery,
  useAddGradeMutation,
  useUpdateGradeMutation,
  useDeleteGradeMutation,
} = gradeApi;
